import MediaFile from 'Flow2/util/MediaFile';
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";


class Clip {
    static parseClip(clip, playerDerivatives, newFirst = false) {

        //const config =  store.getState().ui.config;

        //let preview = null;
        let mainThumb = clip.mainthumbnail !== null ? clip.mainthumbnail.url : null;
        if (mainThumb === null && clip.thumbnails.elements.length > 0) {
            mainThumb = clip.thumbnails.elements[0].url;
        }

        let mainmediafile = Clip.getMainMediafile(clip, playerDerivatives);
        
        let mediaTypes = [];
        mediaTypes = Object.keys(clip.media.fields);
        
        // clip.addEventListener("update", (e) => {console.log('updated')});
        return {
            id: clip.metadata.fields.id || clip.metadata.fields.clipid || clip.id,
            title: clip.metadata.titel_de,
            status: clip.status,
            mainthumbnail: mainThumb,
            metadata: clip.metadata.fields,
            mainmediafile: mainmediafile,
            mediafiles: clip.mediafiles.elements,
            thumbnails: clip.thumbnails.elements,
            media: mediaTypes,
            mediaType: MediaFile.getMediaType(mediaTypes, clip.mediafiles.elements),
            originalObject: clip,
        };
    }

    static isSelectedInRoom(clip, clId) {
        let ret = false;
        if (clip.metadata.specifics) {
            try {
                let specifics = JSON.parse(clip.metadata.specifics);
                if (specifics && specifics.customtags && specifics.customtags[clId]) {
                    Object.keys(specifics.customtags[clId]).forEach(key => {
                        if (specifics.customtags[clId][key].indexOf('newsroompublish') > -1) {
                            ret = true;
                        }
                    });
                }
            } catch (e) {
                console.log(e);
            }
        }
        return ret;
    }

    static getImportStatus(importstatus) {
        const states = ["importing", "processing", "exporting"];
        importstatus = importstatus || "";

        for (let state of states) {
            if (importstatus.indexOf(state) !== -1) {
                return state;
            }
        }

        return "";
    }

    static getDownloadList(clip) {
        const list = [];
        if (clip && clip.mediafiles) {
            clip.mediafiles.forEach((file, index) => {
                list.push({ ...file, information: MediaFile.getInformation(file) });
            });

            list.sort(function (a, b) {
                if (a.information < b.information) { return -1; }
                if (a.information > b.information) { return 1; }
                return 0;
            });
        }

        return list;
    }

    static getLocalAndRemoteIds(props, clips = []) {
        const ids = {
            localIds: [],
            remoteIds: {}
        };

        clips.forEach(dropClip => {
            for (let clip in props.clips) {
                if (props.clips[clip].id === dropClip) {
                    let device = props.clips[clip].originalObject.remoteserverdevice;

                    if (device) {
                        if (!ids.remoteIds.hasOwnProperty(device)) {
                            ids.remoteIds[device] = [dropClip];
                        } else {
                            ids.remoteIds[device].push(dropClip);
                        }
                    } else {
                        ids.localIds.push(dropClip);
                    }

                    break;
                }
            }
        });

        return ids;
    }

    static getMainMediafile(clip, derivatives = [{ field: 'tags', value: 'preview' }]) {
        let mediafiles = clip.mediafiles.elements ? clip.mediafiles.elements : [];
        let mainmediafile = null;
        let i = 0;

        if (mediafiles.length) {
            while (!mainmediafile && i < derivatives.length) {
                /*if(DataUtil.isPorscheArchiv()) {
                    mainmediafile = Clip.findDerivateForPADB(mediafiles, derivatives[i]);
                } else {
                }*/
                mainmediafile = Clip.findDerivate(mediafiles, derivatives[i]);
                i++;
            }
            // no match found >> set first mediafile
            if (!mainmediafile) {
                mainmediafile = mediafiles[0];
            }
        }

        return mainmediafile;
    }

    static findDerivate(mediafiles, derivate) {
        for (let i = 0; i < mediafiles.length; i++) {
            let data = mediafiles[i].data;
            let field = data[derivate.field];

            // make string and split to array to find value
            if (!Array.isArray(field)) {
                field = (data[derivate.field] + "").split(',');
            }

            // check if array contains derivate
            if (field.indexOf(derivate.value) !== -1) {
                return mediafiles[i];
            }
            
            // if not exact compare
            if(!derivate.exact) {
                // check if array values contain substring
                for(let j = 0; j < field.length; j++) {
                    if(field[j].indexOf(derivate.value) !== -1) {
                        return mediafiles[i];
                    }
                }
            }
        }

        return null;
    }
    
    /*
    static findDerivateForPADB(mediafiles, derivate) {
        for (let i = mediafiles.length - 1; i >= 0; i--) {
            let data = mediafiles[i].data;
            let field = data[derivate.field];

            // make string and split to array to find value
            if (!Array.isArray(field)) {
                field = (data[derivate.field] + "").split(',');
            }

            if (field.indexOf(derivate.value) !== -1) {
                return mediafiles[i];
            }
        }

        return null;
    }
    */
}

export default Clip;
